import { render, staticRenderFns } from "./MemberRefund.vue?vue&type=template&id=7970d4a0&scoped=true&"
import script from "./MemberRefund.vue?vue&type=script&lang=js&"
export * from "./MemberRefund.vue?vue&type=script&lang=js&"
import style0 from "./MemberRefund.vue?vue&type=style&index=0&id=7970d4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970d4a0",
  null
  
)

export default component.exports